import React from 'react';
import { connect } from 'react-redux';
import { HashLink as Link } from 'react-router-hash-link';
import {Helmet} from 'react-helmet';
import  PageHeader          from './PageHeader';
import  CtaSection          from './CtaSection';
import  { HomePageS2 }      from './HomePageS2';
import  { HomePageS3 }      from './HomePageS3';
import  { HomePageS4 }      from './HomePageS4';
// import  { FooterSection }      from './FooterSection';
import  Footer              from '../components/common/Footer';
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';
import  getAppConfigParm  from '../config/AppConfig';


// CtaSection is the first section ; this is the Call To Action section
// HomePageS2 is section 2 - What is it ?
// HomePageS3 is section 3 - How it works
// HomePageS4 is section 4 - Welcome Feedback Form
export const ContactFormPage  = (props) =>  (  // use destructing to obtain function prop
    <div>
        <Helmet>
            <title>Contact form - Pitch In Club</title>
            <meta name="description" content="Contact form  - Pitch In Club" />
        </Helmet>

        
        <PageHeader />
        
        <VisibilityWrapper show={getAppConfigParm("showAd")} contentType="advertisement">
        <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
            {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
            {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
            {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
        </div>
        </VisibilityWrapper>  

        <HomePageS4 />
{/*
        <div style={{display: "flex", justifyContent: "center"}}>
                <Link smooth to="/" className="small-text-link" >Home</Link>
        </div>
*/}        
        <VisibilityWrapper show={getAppConfigParm("showAd")} contentType="advertisement" >
            <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
            </div> 
        </VisibilityWrapper>
        <Footer />
    </div>
);
   


// const mapDispatchToProps = (dispatch) => ({
//     startLogin: () => dispatch(startLogin())
// })

// export default connect(undefined, mapDispatchToProps)(LoginPage);
export default connect()(ContactFormPage);




// WEBPACK FOOTER //
// ./src/components/ContactFormPage.js